import type { FormControl } from '@angular/forms';

export type AnimationSettings = {
    isActive: boolean;
    animationType: EAnimationType;
    animationPosition: EAnimationPosition;
    animationSpeed: EAnimationSpeed;
};

export type AnimationSettingsFormControls = {
    isActive: FormControl<boolean>;
    animationType: FormControl<EAnimationType>;
    animationPosition: FormControl<EAnimationPosition>;
    animationSpeed: FormControl<EAnimationSpeed>;
};

export enum EAnimationType {
    fade = 'fade',
    slide = 'slide',
    scale = 'scale',
    runningStripe = 'running_stripe',
}

export enum EAnimationPosition {
    left = 'left',
    top = 'top',
    right = 'right',
    bottom = 'bottom',
    center = 'center',
}

export enum EAnimationSpeed {
    slow = 'slow',
    medium = 'medium',
    fast = 'fast',
}
